export default __webpack_public_path__ + "static/video-dark-b753421b1cc5a8777a4290d1e5290d63.png";